export const config = {
  apiUrl: "https://solo.moonproduct.xyz",
  referrerUrl: "https://referrer.moonproduct.tech/?id=com.moonproduct.solo",
};
